module.exports = __webpack_public_path__ + "static/media/growth.320a02be.svg";